<template>
  <div :class="{copy, 'move': move}" style="height: 100%;">
    <div class="head yp-topbar">
      <ul class="clearfix" id="copy" :class="{'common': common && !shareParentId.length}">
        <span class="back fl" @click="back" v-show="parentId.length || shareParentId.length"></span>
        <li :class="{'shareTarget': !shareTarget,'list': share}" @click="personFile" v-show="!person" v-if="!common">{{index}}</li>
        <li :class="{'shareTarget': shareTarget,'list': kind}" @click="shareFile" v-show="!share">{{shareIndex}}</li>
        <span id="cancel" @click="cancelcopy">取消</span>
      </ul>
      <div class="tip">
        选择目标文件夹
      </div>
    </div>
    <ul class="ulBox" v-on:scroll="moveScroll()" ref="moveBox">
      <li v-for="(item,index) in hello">
        <div class="list">
            <span v-if="slicetype(item.fileName,item.isDir,item.permissionType)!=='icon-package'">
               <i :class="item.fileName | sliceType(item.isDir, item.permissionType)" class="iconfont"></i>
            </span>
          <svg class="icon" aria-hidden="true" v-else>
            <use xlink:href="#icon-package"></use>
          </svg>
          <div class="con">
            <div class="right" @click="next(item.id,item.fileName,item.isDir,item.fileName)">
              <h3>{{item.fileName}}</h3>
              <span>{{item.gmtModified | formaTime}}</span>
            </div>
            <div class="size">{{item.length | bytesToSize}}</div>
          </div>
        </div>
      </li>
    </ul>
    <div class="copy-bottom">
      <span @click="mkdir" v-show="shareTarget" style="width: 49%">新建文件夹</span>
      <span @click="copyEnd" :style="{width: shareTarget ? '49%' : '100%'}">{{model}}</span>
    </div>
  </div>
</template>

<script>
  import apis from '../apis/index'
  import {MessageBox, Toast, Indicator, Popup} from 'mint-ui'
  import cloudApi from '../apis/cloudStorageApi'
  import Vue from 'vue'

  export default {
    name: 'copy',
    data () {
      return {
        hello: [],
        index: '个人文件',
        move: false,
        parentId: [],
        shareParentId: [],
        shareIndex: '共享文件',
        sharePid: '',
        shareFileIds: '',
        shareTarget: true,
//        控制title的样式参数
        share: false,
        person: false,
        kind: false,
        pid: 'rootpath',
        page: 0,
        copypage: 0
      }
    },
    created () {
      let _this = this
      if (_this.common) {
        apis.request(cloudApi.shareFiles, {fileId: _this.shareFileIds, page: 0, size: 20}).then(function (res) {
          _this.hello = res.data.content
        }).catch(function (res) {
        })
      } else {
        apis.request(cloudApi.searchFile, {fileId: _this.pid, page: 0, size: 20}).then(response => {
          _this.hello = response.data.content
        }).catch(function (error) {
        })
      }
      this.slicetype = Vue.filter('sliceType')
      this.shareTarget = !this.common
      this.person = this.common
    },
    methods: {
      copy: function () {

      },
//      确认复制
      copyEnd: function () {
        let _this = this
        var com = _this.model.substring(0, 2)
        if (_this.shareTarget === true) {
          if (com === '复制') {
            apis.request(cloudApi.copyFiles, {fileIds: _this.fileId, targetFileId: _this.pid}).then(function (res) {
              _this.$emit('copy', false)
              Toast({
                message: '文件复制成功',
                iconClass: 'icon-success'
              })
            }).catch(function (error) {
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
            })
          } else if (com === '移动') {
            apis.request(cloudApi.moveFiles, {fileIds: _this.fileId, targetFileId: _this.pid}).then(function (res) {
              _this.$emit('move', _this.fileId)
              Toast({
                message: '文件移动成功',
                iconClass: 'icon-success'
              })
            }).catch(function (error) {
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
            })
          } else if (com === '保存') {
            let assignedShareId = null
            let fileIds = []
            if (this.operaRow.id) {
              assignedShareId = this.operaRow.id
              fileIds.push(this.operaRow.fileId)
            } else {
              this.checkedItems.forEach((value) => {
                assignedShareId = value.id
                fileIds.push(value.fileIds)
              })
            }
            if (!fileIds[0]) {
              fileIds = []
            }
            apis.request(cloudApi.saveOtherShare, {'queryStr': window.encodeURI(JSON.stringify({
              fileArr: [
                {
                  assignedShareId: assignedShareId,
                  fileIds: fileIds
                }
              ],
              targetFileId: _this.pid
            }))}
            ).then((res) => {
              _this.$emit('move', this.operaRow)
              Toast({
                message: '文件保存成功',
                iconClass: 'icon-success'
              })
            }).catch(function (error) {
              console.dir(error)
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
            })
          }
        } else if (_this.shareTarget === false) {
          if (com === '复制') {
            if (_this.sharePid === '') {
              Toast({
                message: '请选择目标文件夹',
                iconClass: 'icon-error'
              })
              return false
            }
            apis.request(cloudApi.copyFiles, {
              fileIds: _this.fileId,
              targetFileId: _this.sharePid
            }).then(function (res) {
              _this.$emit('copy', false)
              Toast({
                message: '文件复制成功',
                iconClass: 'icon-success'
              })
            }).catch(function (error) {
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
            })
          } else if (com === '移动') {
            apis.request(cloudApi.moveFiles, {
              fileIds: _this.fileId,
              targetFileId: _this.sharePid
            }).then(function (res) {
              if (_this.sharePid === '') {
                Toast({
                  message: '请选择目标文件夹',
                  iconClass: 'icon-error'
                })
                return false
              }
              _this.$emit('move', _this.fileId)
              Toast({
                message: '文件移动成功',
                iconClass: 'icon-success'
              })
            }).catch(function (error) {
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
            })
          } else if (com === '保存') {
            let assignedShareId = null
            let fileIds = []
            if (this.operaRow.id) {
              assignedShareId = this.operaRow.id
              fileIds.push(this.operaRow.fileId)
            } else {
              this.checkedItems.forEach((value) => {
                assignedShareId = value.id
                fileIds.push(value.fileIds)
              })
            }
            if (!fileIds[0]) {
              fileIds = []
            }
            apis.request(cloudApi.saveOtherShare, {'queryStr': window.encodeURI(JSON.stringify(
              {
                fileArr: [
                  {
                    assignedShareId: assignedShareId,
                    fileIds: fileIds
                  }
                ],
                targetFileId: _this.pid
              }
            ))}).then(function (res) {
              _this.$emit('move', this.operaRow)
              Toast({
                message: '文件保存成功',
                iconClass: 'icon-success'
              })
            }).catch(function (error) {
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
            })
          }
        }
      },
//      滚动加载
      moveScroll: function () {
        let _this = this
        let ulBox = _this.$refs.moveBox
        if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
          if (_this.shareTarget) {
            _this.page++
            apis.request(cloudApi.searchFile, {fileId: _this.pid, page: _this.page, size: 20}).then(response => {
              let data = response.data.content
              if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                  this.hello.push(data[i])
                }
              }
              return false
            }).catch(function (error) {
            })
          } else {
            _this.copyPage++
            apis.request(cloudApi.shareFiles, {
              fileId: _this.sharePid,
              page: _this.copyPage,
              size: 20
            }).then(response => {
              let data = response.data.content
              if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                  this.hello.push(data[i])
                }
              }
              return false
            }).catch(function (error) {
            })
          }
        }
      },
//      返回上一级
      back: function () {
        let _this = this
        _this.page = 0
        if (_this.shareTarget === true) {
          let length = _this.parentId.length - 1
          let fileId = _this.parentId[length].pid
          _this.whenId = fileId
          apis.request(cloudApi.searchFile, {fileId, page: 0, size: 20}).then(function (res) {
            _this.hello = []
            _this.index = _this.parentId[length].index
            _this.indexs = _this.parentId[length].index
            _this.pid = fileId
            _this.parentId.pop()
            _this.hello = res.data.content
            if (_this.parentId.length === 0) {
              _this.person = false
              _this.share = false
              _this.kind = false
              _this.shareFileIds = ''
            }
          }).catch(function (res) {
          })
        } else if (_this.shareTarget === false) {
          let length = _this.shareParentId.length - 1
          let fileId = _this.shareParentId[length].pid
          apis.request(cloudApi.shareFiles, {fileId, page: 0, size: 20}).then(function (res) {
            _this.hello = []
            _this.copyPage = 0
            _this.shareIndex = _this.shareParentId[length].index
            _this.pid = fileId
            _this.shareFileIds = fileId
            _this.sharePid = fileId
            _this.shareParentId.pop()
            _this.hello = res.data.content
            if (_this.shareParentId.length === 0) {
              _this.person = false
              _this.share = false
              _this.kind = false
              _this.pid = 'rootpath'
            }
          }).catch(function (res) {
          })
        }
      },
//      点击个人文件
      personFile: function () {
        let _this = this
        _this.shareTarget = true
        _this.hello = []
        _this.page = 0
        apis.request(cloudApi.searchFile, {fileId: _this.pid, page: 0, size: 20}).then(response => {
          _this.hello = response.data.content
        }).catch(function (error) {
        })
      },
//      点击共享文件
      shareFile: function () {
        let _this = this
        let ulBox = _this.$refs.moveBox
        ulBox.scrollTop = 0
        _this.shareTarget = false
        _this.copyPage = 0
        apis.request(cloudApi.shareFiles, {fileId: _this.shareFileIds, page: 0, size: 20}).then(function (res) {
          _this.hello = []
          ulBox.scrollTop = 0
          let data = res.data.content
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              _this.hello.push(data[i])
            }
          }
        }).catch(function (res) {
        })
      },
//      取消复制和移动
      cancelcopy: function () {
        this.$emit('copy', false)
      },
//      进入下一级目录
      next: function (index, fileName, isDir) {
        let _this = this
        if (isDir === 1) {
          _this.page = 0
          let ulBox1 = _this.$refs.moveBox
          if (_this.shareTarget === true) {
//            个人文件夹的下一级
            _this.person = false
            _this.share = true
            _this.kind = false
            ulBox1.scrollTop = 0
            apis.request(cloudApi.searchFile, {fileId: index, page: 0, size: 20}).then(function (res) {
              ulBox1.scrollTop = 0
              if (_this.pid === 'rootpath') {
                _this.parentId = [{pid: 'rootpath', index: '个人文件'}]
              } else {
                _this.parentId.push({pid: _this.pid, index: _this.index})
              }
              _this.pid = index
              _this.index = fileName
              _this.hello = res.data.content
              ulBox1.scrollTop = 0
            }).catch(function (res) {
            })
          } else if (_this.shareTarget === false) {
//            共享文件夹的下一级
            _this.person = true
            _this.share = false
            _this.kind = true
            ulBox1.scrollTop = 0
            _this.copyPage = 0
            apis.request(cloudApi.shareFiles, {fileId: index, page: 0, size: 20}).then(function (res) {
              ulBox1.scrollTop = 0
              if (_this.sharePid === '' || _this.shareIndex === '共享文件') {
                _this.shareParentId = [{pid: '', index: '共享文件'}]
              } else {
                _this.shareParentId.push({pid: _this.sharePid, index: _this.shareIndex})
              }
              _this.sharePid = index
              _this.shareFileIds = index
              _this.shareIndex = fileName
              _this.hello = res.data.content
              ulBox1.scrollTop = 0
            }).catch(function (res) {
            })
          }
        }
      },
//      新建文件夹
      mkdir: function () {
        let _this = this
        let ulBox1 = _this.$refs.moveBox
        if (_this.shareTarget) {
          MessageBox.prompt('新建文件夹', '', {
            inputValue: '新建文件夹',
            className: 'fs',
            showInput: true,
            inputPattern: /\S/,
            inputErrorMessage: '名字不允许为空',
            confirmButtonClass: 'btnClass'
          }).then(({value, action}) => {
            if (action === 'confirm' && value !== null) {
              apis.request(cloudApi.mKdir, {dirName: value, pid: this.pid}).then(function (response) {
                _this.parentId.push({pid: _this.pid, index: _this.index})
                _this.pid = response.data.id
                _this.index = value
                _this.person = false
                _this.share = true
                _this.kind = false
                apis.request(cloudApi.searchFile, {fileId: _this.pid, page: 0, size: 20}).then(function (response) {
                  let data = response.data.content
                  if (_this.hello.length > 0) {
                    ulBox1.scrollTop = 0
                  }
                  _this.hello = data
                  Toast({
                    message: '新建成功',
                    iconClass: 'icon-success'
                  })
                })
                this.$store.commit('changeId', _this.pid)
              }).catch(function (error) {
                Toast({
                  message: error.response.data.message,
                  iconClass: 'icon-error'
                })
              })
            }
          })
        } else {
          MessageBox.prompt('新建文件夹', '', {
            inputValue: '新建文件夹',
            showInput: true,
            inputPattern: /\S/,
            inputErrorMessage: '名字不允许为空'
          }).then(({value, action}) => {
            if (action === 'confirm' && value !== null) {
              apis.request(cloudApi.mKDir, {dirName: value, pid: this.sharePid}).then(function (response) {
                _this.shareParentId.push({pid: _this.sharePid, index: _this.shareIndex})
                _this.sharePid = response.data.id
                _this.shareIndex = response.data.fileName
                _this.person = true
                _this.share = false
                _this.kind = true
                apis.request(cloudApi.shareFiles, {
                  fileId: _this.sharePid,
                  page: 0,
                  size: 20
                }).then(function (response) {
                  let data = response.data.content
                  if (_this.hello.length > 0) {
                    ulBox1.scrollTop = 0
                  }
                  _this.hello = data
                  _this.copyPage = 0
                  Toast({
                    message: '新建成功',
                    iconClass: 'icon-success'
                  })
                })
              }).catch(function (error) {
                Toast({
                  message: error.response.data.message,
                  iconClass: 'icon-error'
                })
              })
            }
          })
        }
      }
    },
    props: ['fileId', 'model', 'common', 'checkedItems', 'operaRow']
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
  .iconfont {
    font-size: 0.62rem;
  }

  .mint-popup {
    width: 100%;
    z-index: 2001;
    height: 100%;
    overflow: auto;
  }

  .icon-success {
    background: url("../assets/images/success_icon.png");
  }

  body {
    font-size: 0.16rem !important;
  }

  [v-cloak] {
    display: none;
  }

  .hello {
    height: 100%;
    padding-top: 1.28rem;
    padding-bottom: 0.98rem;
  }

  #title {
    width: 50%;
    margin: 0 auto;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
  }

  .right h3 {
    height: 0.4rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.28rem;
    color: #1d1f22;
  }

  .right span {
    font-size: 0.2rem;
    color: #9b9b9b;
    vertical-align: middle;
  }

  h1, h2, h3 {
    font-weight: normal;
    margin: 0;
    line-height: initial;
  }

  h3 {
    text-align: left;
  }

  /*顶部样式*/
  .head {
    font-size: 0.36rem !important;
    position: fixed;
    top: 0;
    width: 100%;
    height: 1.28rem;
    line-height: 0.88rem;
    -webkit-backdrop-filter: blur(40px);
    backdrop-filter: blur(40px);
    color: #fff;
    z-index: 999;
  }

  .head ul {
    text-align: center;
    position: relative;
    margin-top: 0.4rem;
  }

  #head ul li:nth-of-type(n+2) {
    float: right;
    width: 0.36rem;
    height: 0.36rem;
    position: absolute;
    right: 0;
    top: 0.25rem;
  }

  #head ul li:last-of-type {
    right: 0.66rem;
  }

  /*无内容时样式*/
  .jpg {
    position: relative;
    height: 100%;
  }

  .jpg div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .jpg div p {
    font-size: 0.28rem;
    color: #41464c;
  }

  /*有内容时的样式*/
  .ulBox {
    height: 100%;
    overflow-y: scroll;
    background-color: #fff;
    /*padding-bottom: .86rem;*/
  }

  .list {
    padding-left: 0.3rem;
    width: 80%;
  }

  .btn {
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    color: #fff;
  }

  .con {
    display: inline-block;
    width: 70%;
    margin-left: 0.228rem;
  }

  .con .size {
    position: absolute;
    right: 0.64rem;
    top: 0.4rem;
    color: #c7c7c7;
  }

  .icon-default {
    color: #dadcdd;
  }

  .ulBox li {
    border-top: 1px solid #e5e5e5;
    text-align: left;
    position: relative;
  }

  .ulBox > li:last-of-type {
    border-bottom: 1px solid #e5e5e5;
  }

  .ulBox li:first-child #moreh {
    display: none;
  }

  .ulBox li div:first-of-type {
    box-sizing: border-box;
  }

  .ulBox .list {
    height: 0.99rem;
    padding-top: 0.14rem;
  }

  .ulBox li img {
    float: left;
    width: 0.5rem;
    height: 0.5rem;
    display: inline-block;
  }

  @keyframes move {
    from {
      top: 800px;
    }
    to {
      top: 0;
    }
  }

  .copy {
    height: 100%;
    width: 100%;
    top: 0px;
  }

  .move {
    animation: move 5s;
  }

  .copy-bottom {
    //line-height: 0.98rem;
    position: fixed;
    width: 100%;
    bottom: 0;
    // height: 0.98rem;
    background-color: #3f4b5f;
    padding: 5px 20px;
  }

  .copy-bottom span {
    height: 0.75rem;
    border-radius: 10px;
    background-color: #7b8ca9;
    color: #fff;
    font-size: 0.28rem;
    display: inline-block;
    text-align: center;
    line-height: 0.75rem;
  }

  .copy-bottom span:last-of-type {
    background-color: #E4393C;
  }

  .tip {
    height: 0.6rem;
    line-height: 0.6rem;
    background-color: #f7f7fa;
    color: #666;
    font-size: 0.24rem;
    text-align: center;
  }

  .common {
    /*text-align: center;*/
    li {
      float: none !important;
      display: inline-block;
    }
  }

  #copy {
    padding: 0 2rem;
    position: relative;
  }

  #copy .back {
    position: absolute;
    left: 0.3rem;
  }

  #copy li {
    float: left;
    position: initial;
    width: 50%;
  }

  #copy .list {
    width: 90%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  #cancel {
    position: absolute;
    right: 0.3rem;
    font-size: 0.28rem;
  }

  .shareTarget {
    opacity: 0.6;
  }

  .back {
    width: 0.2rem;
    height: 0.35rem;
    background: url("../assets/images/back-mobile.png") center no-repeat;
    background-size: 0.2rem 0.35rem;
    top: 0.26rem;
    position: absolute;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/copy.vue